import { useState } from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ImportDashboard } from "@/pages/v2/import/components/import-dashboard";
import { ImportWizardSheet } from "@/pages/v2/import/wizard";

export default function V2SettingsDataImportPage() {
  const [wizardOpen, setWizardOpen] = useState(false);

  const newImportButton = (
    <Button size="sm" onClick={() => setWizardOpen(true)}>
      <Upload className="size-4" /> New import
    </Button>
  );

  return (
    <>
      <ImportDashboard
        breadcrumbs={[
          { label: "Settings", href: "/settings" },
          { label: "Data Import" },
        ]}
        title="Data Import"
        subtitle="Import customer, location, and other records from a CSV. Past imports appear below."
        actions={newImportButton}
        reviewBaseHref="/import/jobs"
        emptyAction={{
          label: "New import",
          onClick: () => setWizardOpen(true),
        }}
      />
      <ImportWizardSheet open={wizardOpen} onOpenChange={setWizardOpen} />
    </>
  );
}
